import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { displayMessage } from '../../Utils/helper';
import Loader from '../common/Loader';
import AuthService from '../../services/AuthService';



const { REACT_APP_API_BASE_URL } = process.env

const SalesPersonSelection = ({ salesPersonList, workflow_id, approvStatus }) => {
    const navigate = useNavigate()
    // console.log("approvStatus", approvStatus);

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsID, setSelectedOptionsID] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    //console.log(salesPersonList);


    const handleSelect = (sp) => {
        if (selectedOptions.includes(sp.sp_name)) {
            // Remove from selected options
            setSelectedOptions(selectedOptions.filter((item) => item !== sp.sp_name));
            setSelectedOptionsID(selectedOptionsID.filter((item) => item !== sp.sp_id))
        } else {
            // Add to selected options
            setSelectedOptions([...selectedOptions, sp.sp_name]);
            setSelectedOptionsID([...selectedOptionsID, sp.sp_id]);
        }
    };


    const sendMailSKU = async () => {
        setIsLoading(true)
        try {
            // Construct the full URL by directly appending the query parameter
            const url = `${REACT_APP_API_BASE_URL}/send_email_f_skus`;
            const payload = {
                "sp_ids": selectedOptionsID,
                "workflow_ids": [`${workflow_id}`],
                "Authorization" : AuthService.getAccessToken(),
                "access_token" : AuthService.getAccessToken()
            }
            // 
            // Perform the post request
            const response = await axios.post(url, payload, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    // access_token: UserService.getToken(), // Replace with your token retrieval function
                },
            });

            // Handle the response
            console.log(response.data);
            if (response.data.failed === 0) displayMessage('success', 'Mail Sent Successfully', '');
            else displayMessage('danger', 'Error', "");
            // setSalesPersonList(response.data.data);


        } catch (error) {
            // Handle errors
            console.error("Error fetching workflows:", error.message);
            displayMessage('danger', 'Error', '');
            throw error;
        }
        setIsLoading(false)
    }

    return (
        <>
            <h2 style={{ margin: "5vh 0 5vh 0" }} className="text-3xl font-bold mb-4 text-center">Sales Person</h2>
            <div style={{ marginTop: "5vh 0 5vh 0" }} className="mycontainer manage-workflow-box">
                {approvStatus.toLowerCase() === "approved" && <div className="p-4 w-full">
                    Approved.
                </div>}
                {approvStatus.toLowerCase() !== "approved" && <div className="p-4 w-full">
                    {/* Wrapper for dropdown and selected items */}
                    <div className="flex flex-col md:flex-row gap-4 items-start w-full">
                        {/* Dropdown (left side) */}
                        <div className="flex-1 w-full md:w-1/2">
                            <div className="border border-gray-300 rounded p-2 bg-white">
                                <h3 className="text-md font-bold mb-2">Select from List:</h3>
                                <div className="overflow-auto max-h-74">
                                    {salesPersonList.length &&
                                        salesPersonList.map((item) => (
                                            <div
                                                key={item.sp_id}
                                                className="flex items-center gap-2 p-2 hover:bg-gray-200"
                                            >
                                                <input
                                                    type="checkbox"
                                                    id={item.sp_id}
                                                    checked={
                                                        selectedOptions.includes(item.sp_name)
                                                    }
                                                    onChange={() => handleSelect(item)}
                                                    className="cursor-pointer"
                                                />
                                                <label
                                                    htmlFor={item.sp_id}
                                                    className="cursor-pointer text-sm relative top-3"
                                                >
                                                    {item.sp_name}
                                                </label>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>

                        {/* Selected items (right side) */}
                        <div className="flex-1 w-full md:w-1/2">
                            <div className="bg-gray-100 rounded p-2">
                                <h3 className="text-md font-bold mb-2">
                                    Selected Sales Person
                                    {selectedOptions && selectedOptions.length > 1 ? "s" : ""}
                                </h3>
                                <div className="overflow-auto max-h-64">
                                    {selectedOptions.length > 0 ? (
                                        <ul className="list-disc list-inside">
                                            {selectedOptions.map((option, index) => (
                                                <li key={index} className="text-2x">
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className="text-lg text-gray-500">No items selected</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Send button */}
                    <div style={{ margin: "5vh 0 5vh 0" }} className="text-center">
                        {isLoading ?
                            <center><Loader size={'large'} /></center>
                            :
                            <button
                                onClick={() => sendMailSKU()}
                                className="bg-[#0C3C54] text-white px-5 py-2 rounded hover:bg-[#0C3C40]"
                            >
                                SEND
                            </button>}
                    </div>
                </div>}
            </div>
        </>
    )
}

export default SalesPersonSelection